import React from 'react';
import { Modal, ModalHeader, Table} from 'reactstrap';
import '../Icono/cardIcon.css';
import { PersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';
import { TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface MiModalProps {
    isOpen: boolean;
    toggle: () => void;
    data: PersonaInvDTO;

}

export const ModalDetalleUsuario: React.FC<MiModalProps> = ({ isOpen, toggle, data }) =>{
    return (
        <Modal className='modal-lg' isOpen={isOpen} toggle={toggle}>
            <ModalHeader><strong>Detalle de usuario</strong></ModalHeader>
            <div style={{padding:'20px'}} >
                <div className='containerModal' >
                    <div className='labelModal'>Usuario:</div>
                    <div className='contentModal'>{data?.nombreCompleto}</div>
                </div>
                <div className='containerModal' >
                    <div className='labelModal'>Correo:</div>
                    <div className='contentModal'>{data?.email}</div>
                </div>
                <div className='containerModal' >
                    <div className='labelModal'>OrcID:</div>
                    <div className='contentModal'>{data?.orcid ? data.orcid : '---'}</div>
                </div>
                <div className='containerModal' >
                    <div className='labelModal'>ScopusID:</div>
                    <div className='contentModal'>{data?.scopusid ? data.scopusid : '---'}</div>
                </div>
                <div className='containerModal' >
                    <div className='labelModal'>HIndex:</div>
                    <div className='contentModal'>{data?.hindex ? data.hindex : '---' }</div>
                </div>
                <div className='containerModal' >
                    <div className='labelModal'>Google scholar ID:</div>
                    <div className='contentModal'>{data?.scholarid ? data.scholarid : '---'}</div>
                </div>
                <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Rol</TableCell>
                                        <TableCell>Unidad</TableCell>
                                        <TableCell>Estado</TableCell>
                                        {/* <TableCell>Eliminar</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.roles.length > 0 ?
                                        <>
                                            {data.roles.map((rol, index) => (
                                                <TableRow key={'rol-' + index}>
                                                    <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                    <TableCell style={{ width: '50%' }}>
                                                        {rol.nombreRol}
                                                    </TableCell>
                                                    <TableCell style={{ width: '50%' }}>
                                                        {rol.nombreUnidad}
                                                    </TableCell>
                                                    <TableCell style={{ width: '50%' }}>
                                                        {rol.estado === 'A' ? 'Activo' : 'Inactivo'}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                        : <></>}

                                </TableBody>
                            </Table>
            </div>
        </Modal>
    )

}